export default __webpack_public_path__ + "static/media/herosectionSVG.f2889fbf.svg";